// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"04254071","239":"3a65871d","453":"869d58d3","553":"3b7277d1"}[chunkId] + ".chunk.js";
};